import { render, staticRenderFns } from "./goals-select.vue?vue&type=template&id=1052ce00"
import script from "./goals-select.vue?vue&type=script&lang=js"
export * from "./goals-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports